import { render, staticRenderFns } from "./json-editor.vue?vue&type=template&id=40b9c0a0&"
import script from "./json-editor.vue?vue&type=script&lang=js&"
export * from "./json-editor.vue?vue&type=script&lang=js&"
import style0 from "./json-editor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../exo_admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports